import { type FC } from "react";

import { useQuery } from "@apollo/client";
import { css } from "@emotion/css";
import { Alert, Spacing } from "@snapchat/snap-design-system";

import { LensAutomationToolMaintenanceStatus } from "../../gql-generated/types";
import {
    LensAutomationToolAlertDescription,
    LensAutomationToolAlertTitle,
} from "../../lens-creator-payout/components/messages.generated";
import {
    type GetLensAutomationToolMaintenanceStatusQuery,
    type GetLensAutomationToolMaintenanceStatusQueryVariables,
    getLensAutomationToolMaintenanceStatus,
} from "../api/queries";

const marginBottom = css`
    margin-bottom: ${Spacing.LG}px;
`;

export const LensAutomationToolAlert: FC = () => {
    const { data } = useQuery<
        GetLensAutomationToolMaintenanceStatusQuery,
        GetLensAutomationToolMaintenanceStatusQueryVariables
    >(getLensAutomationToolMaintenanceStatus);

    const lensAutomationToolMaintenanceStatus = data?.getLensAutomationToolMaintenanceStatus.status;

    if (
        !lensAutomationToolMaintenanceStatus ||
        lensAutomationToolMaintenanceStatus ===
            LensAutomationToolMaintenanceStatus.LensAutomationToolMaintenanceStatusOff
    )
        return null;

    return (
        <>
            <Alert
                className={marginBottom}
                status="error"
                title={<LensAutomationToolAlertTitle />}
                description={<LensAutomationToolAlertDescription />}
                closable
            />
        </>
    );
};
